import gsap from "gsap";

function animateOnVisible(element, animationFunction, once = true) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          animationFunction();
          if (once) observer.unobserve(entry.target);
        }
      });
    },
    {
      rootMargin: "0px",
      threshold: 0.1,
    }
  );

  observer.observe(element);
}

document.addEventListener("DOMContentLoaded", () => {
  const newPropsElement = document.querySelector(".newprops");
  if (!newPropsElement) return;

  const logoElement = document.querySelector(".newprops__wrapper__logo");
  const listItems = document.querySelectorAll(".newprops__wrapper__list__item");

  if (!logoElement || !listItems.length) return;

  animateOnVisible(logoElement, () => {
    gsap.fromTo(
      logoElement,
      { y: 50, opacity: 0 },
      { y: 0, opacity: 1, duration: 1, ease: "power2.out" }
    );
  });

  animateOnVisible(listItems[0].parentElement, () => {
    gsap.fromTo(
      listItems,
      { y: 30, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.8, stagger: 0.1, ease: "power2.out" }
    );
  });
});
